import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {GlobalMessage} from '../models/global-message';
import * as GlobalMessageActions from '../actions/global-message.actions';
import {createReducer, on} from '@ngrx/store';

export interface State extends EntityState<GlobalMessage> {
}

export const adapter: EntityAdapter<GlobalMessage> = createEntityAdapter<GlobalMessage>({
    selectId: (message) => message.id,
});

export const initialState: State = adapter.getInitialState();

export const reducer = createReducer(
    initialState,
    on(GlobalMessageActions.addMessage, (state, {globalMessage}) => {
        return adapter.addOne(
            globalMessage,
            state
        );
    }),
    on(GlobalMessageActions.dismissMessage, (state, {globalMessage}) => {
        return adapter.removeOne(
            globalMessage.id,
            state
        );
    }),
);

export const {
    selectAll: selectAllMessages,
} = adapter.getSelectors();
